





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Meter, MetersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    api: 'metersApi'
  })
})
export default class AddMeterReading extends Vue {
  private api!: MetersApi;

  @Prop({ required: true })
  private meters!: Meter[];

  @Prop({ required: false })
  private disabled!: boolean;

  private popoverOpen = false;

  private meterId: number | null = null;
  private reading: number | null = null;
  private notes = '';

  private get meterUnits() {
    const index = this.meters.findIndex((m) => m.meterID === this.meterId);
    return this.meters[index].meterUnits;
  }

  async addReading() {
    if (this.meterId && this.reading) {
      await this.api.addMeterReading({
        meterId: this.meterId,
        currentReading: this.reading,
        notes: this.notes
      });
      this.$emit('reading-added');
      this.popoverOpen = false;
      this.meterId = null;
      this.reading = null;
      this.notes = '';
    }
  }
  cancelReading() {
    this.meterId = null;
    this.reading = null;
    this.notes = '';
    this.popoverOpen = false;
  }
}
